<template>
  <Modal v-model="changeSpecificationsModal" footer-hide width="1100" :title="$t('key1006772')" :transfer="false"
    :mask-closable="false" class-name="commonModalStyles" @on-visible-change="changeSpecificationsChange">
    <div class="exhibition-box" v-if="details">
      <div class="exhibition-left">
        <img-zoom ref="imgBox" :imgZoomList="imgZoomList" :details="details" :showEnlargedView="false"></img-zoom>
      </div>
      <div class="exhibition-right">
        <div class="flex flex-wrap mb8">
          <h2 class="exhibition-title" :title="details.name">{{ details.name }}</h2>
        </div>
        <div class="grounding-box">
          <span class="text">SPU：{{ details.ymsSpu }}</span>
          <span class="text">SKU：{{ commodityDetails.ymsSku }}</span>
        </div>
        <!--发货地-->
        <div class="grounding-box">
          <div class="flex align-items-center">
            <span class="color-333 font-weight-bold">{{ $t('key1002433') }}</span>
            <Select size="small" v-model="placeOfShipment" class="width_150" @on-change="deliveryLocationChange" transfer>
              <Option v-for="item in placeOfShipmentList" :key="item.ymsDeliveryPlaceId" :value="item.ymsDeliveryPlaceId">{{ item.deliveryPlaceName }}</Option>
            </Select>
          </div>
        </div>
        <!--发货仓-->
        <div class="flex align-items-start mt10 mb10">
          <span class="color-333 font-weight-bold" style="position: relative; top: 2px;">{{ $t('key1001227') }}</span>
          <RadioGroup v-model="shippingWarehouse" class="shippingWarehouse_box" @on-change="shippingWarehouseChange">
            <Radio v-for="item in shippingWarehouseList" :label="item.ymsWarehouseId" class="shippingWarehouse_item">
              <div class="flex align-items-center">
                <span class="font-size-12">{{ item.name }}</span>
                <Button size="small" type="primary" class="ml5">
                  <span class="display-inline-block mr5">{{ item.warehouseType === 1 ? $t('key1002589') : $t('key1006734') }}</span>
                  <Tooltip transfer placement="top" max-width="500" :content="item.warehouseType === 1 ?
                        $t('key1006730') : $t('key1006731')">
                    <Icon class="help_icon" size="17" type="md-alert"></Icon>
                  </Tooltip>
                </Button>
              </div>
            </Radio>
          </RadioGroup>
        </div>
        <!--规格-->
        <div v-for="(item,idx) in newProductGoodsList" class="mb15">
          <div class="flex align-items-center mb5">
            <h3 class="font-size-14 color-333 font-weight-bold">{{ item.name }}</h3>
            <span class="color-666 ml4 font-size-13">{{ '(' + item.selectValue + ')' }}</span>
          </div>
          <div class="flex flex-wrap" v-if="item.isMainAttribute === 1">
            <div class="specificationImage_box"
              v-for="(ele, ids) in item.values"
              :title="ele.isDisabled ? $t('key1006732') : ''"
              :class="ele.isDisabled ? 'specificationImageDisabled' : ids === item.currentIndex && !ele.isDisabled ? 'specification_active' : ''">
              <img class="img_style_item" :src="setImgPath(ele.imgPath, null, '70x70', null, true)"
                alt="" @click="selectSpecifications('primaryAttribute', idx, ids, ele)">
            </div>
          </div>
          <div class="flex flex-wrap" v-else>
            <span class="specificationValue_box"
              :title="ele.isDisabled ? $t('key1006732') : ''"
              :class="ele.isDisabled ? 'specificationValueDisabled' : ids === item.currentIndex ? 'specification_active' : ''"
              v-for="(ele,ids) in item.values" @click="selectSpecifications('current', idx, ids, ele)">
              {{ ele.value }}
            </span>
          </div>
        </div>
        <!--数量-->
        <div class="flex align-items-center mb15">
          <h3 class="font-size-14 color-333 font-weight-bold">{{ $t('key1005987') }}</h3>
          <div class="quantityOfGoods_box">
            <button :disabled="quantityOfGoods <= 1" :style="quantityOfGoods <= 1 ?  {color: '#E6E6E6'} : ''"
              @click="quantityBtn('minus')" class="quantity_btn">－</button>
            <input type="text" v-model="inputValue" @input="validateInput" class="quantity_input_box"/>
            <button @click="quantityBtn('add')" class="quantity_btn">＋</button>
          </div>
          <span class="distributorThemeColor ml8">{{ $t('key1006443') + totalWeight }}g</span>
          <template v-if="userInfo">
            <span class="distributorThemeColor ml30">{{ $t('key1003367') + commodityInventory }}</span>
            <span class="distributorThemeColor ml30">
              {{ $t('key1006735') + commodityDetails.length + ' * ' + commodityDetails.width + ' * ' + commodityDetails.height }}
            </span>
          </template>
          <template v-else>
            <span class="distributorThemeColor ml50 mr8">{{ $t('key1006741') }}</span>
          </template>
        </div>
        <!--价格-->
        <div class="price_box">
          <template v-if="userInfo">
            <span class="amount">{{ totalPriceOfGoods }}</span>
            <span class="currency">{{ '(' + currencyState + ')' }}</span>
          </template>
          <template v-else>
            <span class="distributorThemeColor">{{ $t('key1006742') }}</span>
          </template>
        </div>
        <div class="flex align-items-center justify-content-between width_400">
          <Button size="large" type="primary" class="width_180" @click="replaceBtn">{{ $t('key1005043') }}</Button>
          <Button size="large" class="width_180" @click="changeSpecificationsModal = false">{{ $t('key1000112') }}</Button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import imgZoom from "@/components/layout/shopping/common/imgZoom.vue";
import {amountHandel, getBatchDeliveryAreasName, getTrialPrice, commonLocalStorage} from "@/utils/common";

export default {
  name: 'changeSpecificationsModal',
  mixins: [Mixin],
  data() {
    return {
      changeSpecificationsModal: false,
      details: null,
      imgZoomList: [],
      newProductGoodsList: [],
      commodityDetails: {},
      inputValue: '1',
      quantityOfGoods: 1,
      replaceYmsProductGoodsId: null,
      originalProductGoodsList: [],
      placeOfShipment: null, // 发货地
      placeOfShipmentList: [], // 发货地列表
      availableWarehousesList: [], // 当前商品的可用仓库
      shippingWarehouse: null, // 发货仓
      shippingWarehouseList: [], // 发货仓列表
      commodityInventory: 0, // 商品库存（从接口获取）
      goodsInventoryResult: [], // 库存详情接口返回数据
      totalPriceOfGoods: 0, // 商品总价格（从接口试算获取）
      originalAttributesData: [], // 属性模板的基础数据
    }
  },
  computed: {
    // 商品总重量
    totalWeight() {
      let quantity = Number(this.inputValue) || 0;
      return (this.commodityDetails.weight || 0) * quantity;
    },
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    fromListing() {
      return this.$store.state.fromListing
    },
  },
  methods: {
    // 初始化数据
    initChangeSpecificationsData(items) {
      this.replaceYmsProductGoodsId = items.ymsProductGoodsId;
      let url = api.get_ymsProductInfo_shopping + items.ymsProductId + `?distributorMerchantId=${this.userInfo.merchantId}`;
      this.axios.get(url).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            this.getItemAttributesData(data).then((attributesData) => {
              this.details = data;
              this.originalAttributesData = (attributesData.ymsCategoryProductAttributeList || []).filter((item) => item.attributeType === 1);

              // 处理发货地数据
              let arr = data.availableWarehouses || [];
              arr.forEach((item) => {
                item.name = item.aliasWarehouseName || item.name;
              })
              this.availableWarehousesList = arr;
              if (this.availableWarehousesList.length > 0) {
                let ymsDeliveryPlaceIds = this.availableWarehousesList.map(item => item.ymsDeliveryPlaceId).filter(Boolean);
                ymsDeliveryPlaceIds = this.uniqueFunc(ymsDeliveryPlaceIds);
                if (ymsDeliveryPlaceIds.length > 0) {
                  getBatchDeliveryAreasName(ymsDeliveryPlaceIds).then((newData) => {
                    if (newData.length > 0) {
                      this.placeOfShipmentList = newData;
                      let ymsDeliveryPlaceId = commonLocalStorage.getItem('ymsDeliveryPlaceId');
                      let talg = this.placeOfShipmentList.some((item) => item.ymsDeliveryPlaceId === ymsDeliveryPlaceId);
                      if (talg) {
                        this.placeOfShipment = ymsDeliveryPlaceId;
                      } else {
                        this.placeOfShipment = newData[0].ymsDeliveryPlaceId;
                      }
                      this.handleShipmentWarehouseData(this.placeOfShipment);
                    }
                  })
                }
              }

              let productImageList = this.details.productImageList || [];
              let productColorImageList = this.details.productColorImageList || [];
              [...productImageList, ...productColorImageList].forEach(i => {
                if (i.path && (i.path.includes('http') || i.path.includes('https'))) {
                  this.imgZoomList.push(i);
                }
              });
              this.changeSpecificationsModal = true;
            });
          }
        }
      });
    },
    // 获取物品属性的基础数据
    getItemAttributesData(details) {
      let ymsProductCategoryId = details.ymsProductCategoryId;
      return new Promise((resolve) => {
        if (ymsProductCategoryId) {
          this.axios.get(api.get_ymsProductCategory_shopping + `${ymsProductCategoryId}`, {loading: true}).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              resolve(data);
            }
          })
        }
      });
    },
    // 处理发货仓数据
    handleShipmentWarehouseData(value) {
      this.shippingWarehouseList = [];
      let newList = this.availableWarehousesList.filter((item) => item.ymsDeliveryPlaceId === value);
      if (newList.length > 0) {
        newList.forEach((item) => {
          let ymsWarehouseDeliverySettings = item.ymsWarehouseDeliverySettings || [];
          item['warehouseType'] = (item.isDeliveryWarehouse === 1 && ymsWarehouseDeliverySettings.length > 0) ? 3 : 1;
        });
        this.shippingWarehouseList = newList;
        if (newList.length > 0) {
          this.shippingWarehouse = newList[0].ymsWarehouseId;
          this.shippingWarehouseChange(this.shippingWarehouse);
        }
      }
    },
    // 切换发货地
    deliveryLocationChange(value) {
      this.handleShipmentWarehouseData(value);
    },
    // 切换发货仓
    shippingWarehouseChange(value) {
      this.commodityInventory = 0;
      this.goodsInventoryResult = [];
      let warehouseType = this.shippingWarehouseList.find((item) => item.ymsWarehouseId === value).warehouseType;
      let query = {
        warehouseType: warehouseType, // 1 中心仓 2 美西仓 3 供应商(三方)
        ymsProductId: this.details.ymsProductId,
        ymsWarehouseId: value
      };
      this.axios.post(api.post_ymsProductInfo_shopping_inventoryDetail, query,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            this.goodsInventoryResult = data.goodsInventoryResult || [];
            this.handleSpecificationData(this.details, this.goodsInventoryResult);
          }
        }
      });
    },
    // 处理规格数据（结合库存数据）
    handleSpecificationData(data, goodsInventoryResult) {
      let specificationData = this.originalAttributesData || [];
      let newProductGoodsList = [];
      let productGoodsList = [];
      if (data.shelveStatus === 1) {
        productGoodsList = (data.productGoodsList || []).filter((item) => item.status === 1);
      } else {
        productGoodsList = data.productGoodsList || [];
      }
      const inventoryMap = new Map(goodsInventoryResult.map(i => [i.ymsSku, i.availableNumber]));
      productGoodsList.forEach(item => {
        const stock = inventoryMap.get(item.ymsSku);
        item.isDisabled = stock === undefined || stock <= 0;
      });
      let groupedAll = {};
      productGoodsList.forEach(item => {
        if (item.status === 1) {
          item.orgin_suggestPrice = item.suggestPrice;
        }
        let priceFields = [
          {value: item.activityPriceValue, field: 'activityPriceValue'},
          {value: item.suggestPrice, field: 'suggestPrice'}
        ];
        if (item.freightDiscount !== 1) {
          priceFields.push({value: item.freightDiscountPrice, field: 'freightDiscountPrice'});
        }
        let newPriceFields = priceFields.filter(price => price.value != null);
        const minPrice = Math.min(...newPriceFields.map(price => price.value));
        item.price = amountHandel(minPrice);
        let {productGoodsSpecifications, ...obj} = item;
        let specs = item.productGoodsSpecifications || [];
        let imgPath = (item.productGoodsImages || [])[0] ? item.productGoodsImages[0].path : null;
        let specificationsValue = [];
        specs.forEach(spec => {
          if (!groupedAll[spec.name]) {
            groupedAll[spec.name] = [];
          }
          if (!groupedAll[spec.name].some(s => s.value === spec.value)) {
            groupedAll[spec.name].push({
              ...spec,
              imgPath: imgPath,
              productGoods: obj
            });
          }
          specificationsValue.push(spec.name + ':' + spec.value);
        });
        item.specificationsValueId = specificationsValue.join('_');
      });
      let productGoodsSpecificationsList = productGoodsList.filter((item) => !item.isDisabled)[0]?.productGoodsSpecifications;
      this.originalProductGoodsList = productGoodsList;
      Object.keys(groupedAll).forEach(key => {
        newProductGoodsList.push({
          currentIndex: 0,
          name: key,
          selectValue: groupedAll[key][0].value,
          values: groupedAll[key]
        });
      });
      if (newProductGoodsList.length > 0) {
        // 构建属性名称映射，避免嵌套循环
        const attrNameMap = {};
        specificationData.forEach(ele => {
          let name = ele.ymsProductAttributeTemplate?.cnName;
          if (name) attrNameMap[name] = ele.isMainAttribute;
        });
        const specSelectMap = {};
        if (productGoodsSpecificationsList) {
          productGoodsSpecificationsList.forEach(k => {
            specSelectMap[k.name] = k.value;
          });
        }
        newProductGoodsList.forEach(item => {
          if (attrNameMap[item.name] !== undefined) item.isMainAttribute = attrNameMap[item.name];
          if (specSelectMap[item.name] !== undefined) item.selectValue = specSelectMap[item.name];
        });
        // 默认选中第一个有库存的规格
        let firstName = productGoodsSpecificationsList ? productGoodsSpecificationsList[0]?.name : null;
        let targetItem = firstName ? newProductGoodsList.find(item => item.name === firstName) : null;
        let info = targetItem ? targetItem.values.find(s => s.value === targetItem.selectValue) : null;
        if (!info) info = newProductGoodsList[0].values[0];
        let obj = info.productGoods;
        let {availableNumber, ymsAvailableNumber, usWestNumber, ...vals} = obj;
        this.commodityDetails = Object.assign({}, {
          ...vals,
          availableNumber: availableNumber || 0,
          ymsAvailableNumber: ymsAvailableNumber || 0,
          usWestNumber: usWestNumber || 0,
        });
        // 从库存结果中匹配当前SKU的库存
        let inventoryItem = goodsInventoryResult.find(item => item.ymsSku === this.commodityDetails.ymsSku);
        if (inventoryItem) this.commodityInventory = inventoryItem.availableNumber;
        // 生成specificationsValueId并标记禁用状态
        this.newProductGoodsList = this.handleSpecValueId(newProductGoodsList);
        this.getCommodityPrice();
      }
    },
    // 生成 specificationsValueId（只基于主属性）
    handleSpecValueId(list) {
      if (!Array.isArray(list) || !list.length) return list;
      const selectedMap = list.reduce((acc, item) => {
        acc[item.name] = item.selectValue;
        return acc;
      }, {});
      const disabledMap = new Map((this.originalProductGoodsList || []).map(i => [i.specificationsValueId, i.isDisabled]));
      list.forEach(spec => {
        spec.values.forEach(val => {
          const specId = Object.keys(selectedMap).map(key => `${key}:${key === spec.name ? val.value : selectedMap[key]}`).join('_');
          this.$set(val, 'specificationsValueId', specId);
          // 无对应在售 SKU 的规格组合不可选（含已过滤的停售 SKU）
          val.isDisabled = disabledMap.has(specId) ? disabledMap.get(specId) : true;
        });
      });
      return list;
    },
    // 获取当前商品在指定仓库下的价格
    getCommodityPrice() {
      if (Object.keys(this.userInfo).length > 0 && this.shippingWarehouse) {
        setTimeout(() => {
          let {ymsProductGoodsId} = this.commodityDetails;
          let query = {
            priceTrialGoodsBoList: [{
              quantity: Number(this.inputValue),
              ymsProductGoodsId: ymsProductGoodsId,
              isNeedCustomization: 0,
            }],
            ymsDistributorMerchantId: this.userInfo.merchantId,
            warehouseIds: [this.shippingWarehouse],
          };
          this.totalPriceOfGoods = 0;
          getTrialPrice(query).then((newData) => {
            if (newData.length > 0) {
              let priceItem = newData.find(item => item.warehouseId === this.shippingWarehouse);
              if (priceItem) this.totalPriceOfGoods = amountHandel(priceItem.goodsPrice);
              this.$forceUpdate();
            }
          });
        }, 700);
      }
    },
    // 选择规格
    selectSpecifications(type, idx, index, obj) {
      let v = this;
      if (obj.isDisabled) return;
      switch (type) {
        case 'primaryAttribute':
          v.$set(v.newProductGoodsList[idx], 'currentIndex', index);
          v.$set(v.newProductGoodsList[idx], 'selectValue', obj.value);
          // 自动切换左侧轮播图
          v.imgZoomList.forEach((item, ids) => {
            if (item.path === obj.imgPath) {
              v.$refs['imgBox'].selectImg(item, ids);
            }
          });
          handleData();
          break;
        case 'current':
          v.$set(v.newProductGoodsList[idx], 'currentIndex', index);
          v.$set(v.newProductGoodsList[idx], 'selectValue', obj.value);
          handleData();
          break;
      }

      function handleData() {
        setTimeout(() => {
          let specificationsValueList = [];
          v.newProductGoodsList = v.handleSpecValueId(v.newProductGoodsList);
          v.newProductGoodsList.map((item) => {
            specificationsValueList.push(item.name + ':' + item.selectValue);
          });
          let targetId = specificationsValueList.join('_');
          v.originalProductGoodsList.map((item) => {
            if (item.specificationsValueId === targetId) {
              let {ymsSku, weight, price, availableNumber, ymsAvailableNumber, usWestNumber, ...vals} = item;
              v.commodityDetails = {
                ...vals,
                ymsSku,
                weight,
                availableNumber: availableNumber || 0,
                ymsAvailableNumber: ymsAvailableNumber || 0,
                usWestNumber: usWestNumber || 0,
                price
              }
              // 从库存结果中匹配当前SKU的库存
              if (v.goodsInventoryResult.length > 0) {
                v.commodityInventory = 0;
                v.goodsInventoryResult.map((ele) => {
                  if (ele.ymsSku === ymsSku) {
                    v.commodityInventory = ele.availableNumber;
                  }
                });
              }
            }
          });
          v.getCommodityPrice();
        }, 200);
      }
    },
    // 加减数量按钮
    quantityBtn(type) {
      const maxQty = this.commodityInventory || 0;
      if (type === 'add') {
        if (this.quantityOfGoods < maxQty) {
          this.quantityOfGoods++;
          this.inputValue = String(this.quantityOfGoods);
          this.getCommodityPrice();
        }
      } else if (type === 'minus') {
        if (this.quantityOfGoods > 1) {
          this.quantityOfGoods--;
          this.inputValue = String(this.quantityOfGoods);
          this.getCommodityPrice();
        }
      }
    },
    // 选择数量
    validateInput() {
      let val = this.inputValue.replace(/\D/g, '') || '1';
      if (val === '0') val = '1';
      const maxQty = this.commodityInventory || 0;
      let numericVal = +val;
      if (numericVal > maxQty) {
        numericVal = maxQty;
        this.inputValue = String(maxQty);
      } else {
        this.inputValue = val;
      }
      this.quantityOfGoods = numericVal;
      this.getCommodityPrice();
    },
    // 更换
    async replaceBtn() {
      try {
        const deleteRes = await this.axios.post(api.post_ymsProductCart_removeProductCart, [this.replaceYmsProductGoodsId],
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')});
        if (deleteRes.data.code === 0) {
          const query = {
            quantity: Number(this.inputValue),
            ymsProductGoodsId: this.commodityDetails.ymsProductGoodsId
          };
          const insertRes = await this.axios.post(api.post_ymsProductCart_insertProductCart, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')});
          if (insertRes.data.code === 0) {
            this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006770'));
            this.changeSpecificationsModal = false;
            this.$emit('updateData', true);
          }
        }
      } catch (err) {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006771'));
      }
    },
    // 监听弹窗
    changeSpecificationsChange(value) {
      if (!value) {
        this.details = null;
        this.imgZoomList = [];
        this.newProductGoodsList = [];
        this.commodityDetails = {};
        this.inputValue = '1';
        this.quantityOfGoods = 1;
        this.replaceYmsProductGoodsId = null;
        this.originalProductGoodsList = [];
        this.placeOfShipment = null;
        this.placeOfShipmentList = [];
        this.availableWarehousesList = [];
        this.shippingWarehouse = null;
        this.shippingWarehouseList = [];
        this.commodityInventory = 0;
        this.goodsInventoryResult = [];
        this.totalPriceOfGoods = 0;
        this.originalAttributesData = [];
        let dom = document.getElementsByClassName('mouse-cover-canvas');
        if (dom) {
          for (let i = 0; i < dom.length; i++) {
            dom[i].style.display = 'none';
          }
        }
      }
    }
  },
  beforeDestroy() {
    let dom = document.getElementsByClassName('mouse-cover-canvas');
    if (dom) {
      for (let i = 0; i < dom.length; i++) {
        dom[i].style.display = 'none';
      }
    }
  },
  components: {
    imgZoom
  }
};
</script>

<style lang="less" scoped>
.exhibition-box {
  width: 100%;
  min-height: 512px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;

  .exhibition-left {
    width: 380px;
  }

  .exhibition-right {
    flex: 1;
    padding-left: 30px;

    .exhibition-title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #1D1D1D;
    }

    .grounding-box {
      display: flex;
      align-items: center;
      margin: 10px 0;

      .text {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FD5425;
        margin-right: 40px;
      }
    }

    .specificationImage_box {
      width: 80px;
      height: 80px;
      border: 1px solid #F4F4F4;
      overflow: hidden;
      border-radius: 4px;
      cursor: pointer;
      margin: 4px 15px 10px 0;
      position: relative;

      .img_style_item {
        left: 50%;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
      }
    }

    .specificationValue_box {
      min-width: 50px;
      display: inline-block;
      text-align: center;
      border: 1px solid #F4F4F4;
      overflow: hidden;
      border-radius: 4px;
      cursor: pointer;
      margin: 0 15px 10px 0;
      font-size: 13px;
      padding: 3px 8px;
    }

    .specification_active {
      border: 2px solid #FD5425;
      color: #FD5425;
    }

    .specificationImageDisabled, .specificationValueDisabled {
      cursor: not-allowed;
      background-color: #FFF;
      opacity: 0.3;

      &:hover {
        border: 2px solid transparent;
        color: #666;
      }
    }

    .shippingWarehouse_box {
      display: flex;
      flex-wrap: wrap;
      max-width: 650px;

      .shippingWarehouse_item {
        margin: 0 25px 12px 0;
        display: flex;
        align-items: center;
      }

      /deep/ .ivu-radio-wrapper {
        font-size: 12px;
      }
    }

    .quantityOfGoods_box {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 0 10px 0 5px;
      width: 130px;
      height: 30px;
      border: 1px solid #E6E6E6;
      border-radius: 30px;
      overflow: hidden;

      .quantity_input_box {
        width: 55px;
        display: inline-block;
        height: 30px;
        line-height: 29px;
        text-align: center;
        font-size: 14px;
      }

      .quantity_btn {
        font-weight: bold;
        color: #333;
        cursor: pointer;
        font-size: 18px;
        padding: 0 10px;
      }
    }

    .price_box {
      margin-bottom: 15px;

      .amount {
        color: #FF4400;
        font-size: 36px;
        font-weight: bold;
      }

      .currency {
        color: #FD5425;
        font-size: 14px;
        margin-left: 6px;
        vertical-align: text-bottom;
      }
    }
  }
}
</style>
